import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { AuthGuard } from '@guards/auth.guard';
import { CashReInvestModalPage } from './cash-reinvest-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  declarations: [CashReInvestModalPage],
  exports: [
    CashReInvestModalPage,
  ],
})
export class CashReInvestModalPageModule {}
